//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { Message } from 'element-ui'
export default {
  data(){
    return {
      tableData: [],
      invSub: false,
      from: {
        source: 0,
        money:'',
        phone: '',
        endTime: '',
        remark: '',
      },
      pageNo:1, 
      total:10,
      provincialList:[
        { value: 0, text: '系统返现'}
      ],
      addBackUserList: []
    }
  },
  mounted(){
    this.info()
  },
  methods:{
    info(pageNo = 1){
      let data = {
        pageNo: pageNo,
        pageSize: 10,
        sysShopId: this.$route.query.shopId
      }
      this.$axios.post('/mtea/cashBack/cashBackList', data).then(res => {
        res.records.forEach(e=>{
          e.totalMoney = (e.totalMoney/100).toFixed(2)
          e.backMoney = (e.backMoney/100).toFixed(2)
          e.pastMoney = (e.pastMoney/100).toFixed(2)
        })
        this.tableData = res.records
        this.total = res.total
        
      }).catch(() => {
        this.tableData = []
        this.total = 0
      })
    },   
    refresh(){
      // 
      let data = {
        sysShopId: this.$route.query.shopId,
      }
      if(this.from.remark) data.desc = this.from.remark
      this.$axios.post('/mtea/cashBack/getStaffLists', data).then(res => {
         this.addBackUserList = []
        res.forEach(e => {
          this.addBackUserList.push({value: e.staffId, text:`${e.userName}(${e.userPhone})`})
        });
      })
      this.invSub = true
    },
    headerStyle(){
      let style = {}
      style.color = '#000'
      style['font-weight'] = 600
      style['text-align'] = 'center'
      style['background-color'] = '#f1f1f1'
      return style
    },
    rowStyle(){
      let style = {}
      style['text-align'] = 'center'
      style['font-size'] = '12px'
      return style
    },
    handleClick(row){
      this.$router.push({name:'alterDetail',query:{shopId:this.$route.query.shopId,cashBackId: row.cashBackId}})
    },
    endTimeChange(val){
      if(new Date(val.value).getTime() < new Date().getTime()){
        this.$message.error('有效期不能为已过去时间！')
        this.from.endTime = ''
      }
    },
    addCallBack(){
      if(this.from.money === ''){
        this.$message.error('请输入返现总金额！')
        return
      }else if(this.from.money<=0){
        this.$message.error('返现总金额不能小于等于0！')
        return
      }else if(isNaN(Number(this.from.money))){
        this.$message.error('返现总金额格式错误！')
        this.from.money = ''
        return
      }else if(this.from.phone === ''){
        this.$message.error('请输入返现账号！')
        return
      }else if(this.from.endTime === ''){
        this.$message.error('请选择有效期！')
        return
      }
      let data = {
        pastTime: this.from.endTime,
        sysShopId: this.$route.query.shopId,
        sysStaffId:this.from.phone,
        totalMoney: this.from.money * 100,
        type: 0,
      }
      if(this.from.remark) data.desc = this.from.remark
      this.$axios.post('/mtea/cashBack/modifyCashBack', data).then(res => {
        this.$message({
            message: '新增成功',
            type: 'success'
        });
        this.invSub = false
        this.info()
      })
    }
  }
}
